import React from "react";
import { Link } from "react-router-dom";

import srvimg1 from "../../images/icon/clipboard.svg";
import srvimg2 from "../../images/icon/briefcase.svg";
import srvimg3 from "../../images/icon/chart.svg";
import srvimg4 from "../../images/icon/badge.svg";
import srvimg5 from "../../images/icon/goal.svg";
import srvimg6 from "../../images/icon/handshake.svg";

const Services = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const service = [
    {
      sIcon: srvimg1,
      title: "Custom Web Development",
      des: "We design and build responsive, SEO-friendly websites tailored to your brand and business goals.",
      link: "/service-single/web-development",
    },
    {
      sIcon: srvimg2,
      title: "Mobile App Development",
      des: "We develop intuitive and scalable mobile apps for iOS and Android to enhance customer engagement.",
      link: "/service-single/mobile-app-development",
    },
    {
      sIcon: srvimg3,
      title: "Full-Stack Solutions",
      des: "From frontend to backend, we craft complete software systems that grow with your business.",
      link: "/service-single/full-stack-solutions",
    },
    {
      sIcon: srvimg4,
      title: "E-commerce Development",
      des: "We build secure and high-performing e-commerce websites to help you sell online effectively.",
      link: "/service-single/ecommerce",
    },
    {
      sIcon: srvimg5,
      title: "IoT Solutions",
      des: "We build intelligent IoT systems that connect devices, streamline operations, and deliver real-time insights to improve decision-making and efficiency.",
      link: "/service-single/iot-solutions",
    },
    {
      sIcon: srvimg6,
      title: "IT Consulting & Support",
      des: "Get expert advice and reliable support to optimize your IT infrastructure and technology decisions.",
      link: "/service-single/it-consulting",
    },
  ];

  return (
    <section className="wpo-service-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="wpo-section-title">
              <span>Our Services</span>
              <h2>Explore Our Services</h2>
            </div>
          </div>
        </div>
        <div className="row">
          {service.map((service, sitem) => (
            <div className="col-lg-4 col-md-6 col-12" key={sitem}>
              <div className="wpo-service-item">
                <div className="wpo-service-icon">
                  <div className="icon">
                    <img src={service.sIcon} alt="" />
                  </div>
                </div>
                <div className="wpo-service-text">
                  <h2>
                    <Link onClick={ClickHandler} to={service.link}>
                      {service.title}
                    </Link>
                  </h2>
                  <p>{service.des}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
